import axios from 'axios'
import { EVENT_PERSONNEL_SPECIAL_SALARY, USER_TOKEN } from "./CONSTANTS";

export const getSpecialSalaries = () => {
    return new Promise((resolve, reject) => {
        axios
        .get(EVENT_PERSONNEL_SPECIAL_SALARY(),{
          headers: {
            'Authorization': `Bearer ${USER_TOKEN()}`
          }
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
};

export const addSpecialSalary = (model) => {
    return new Promise((resolve, reject) => {
        axios
        .post(EVENT_PERSONNEL_SPECIAL_SALARY(), model,{
          headers: {
            'Authorization': `Bearer ${USER_TOKEN()}`
          }
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
};

export const updateSpecialSalary = (model) => {
    return new Promise((resolve, reject) => {
        axios
        .put(EVENT_PERSONNEL_SPECIAL_SALARY(), model,{
          headers: {
            'Authorization': `Bearer ${USER_TOKEN()}`
          }
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
};

export const deleteSpecialSalary = (uniqueKey) => {
    return new Promise((resolve, reject) => {
        axios
        .delete(`${EVENT_PERSONNEL_SPECIAL_SALARY()}/${uniqueKey}`,{
          headers: {
            'Authorization': `Bearer ${USER_TOKEN()}`
          }
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
};
